<template>
  <section class="todo-list-container">
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <comment-table
      @handleBatchAll="handleBatchAll"
      @handlePutReply='handlePutReply'
      @handleReply='handleReply'
      @handlePass='handlePass'
      @handleDelete='handleDelete'
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      v-bind="list"
      :header='header'
      :footButtons="footButtons"
    >
    </comment-table>
    <form-dialog
      :title="causeTitle"
      ref="causeDialog"
      :form="causeForm"
      :rules="causeRules"
      :formItems="causeFormItems"
      v-on:handleConfirm="handleConfirmCause"
      :buttons="causeButtons"
      class="cause-dialog"
    ></form-dialog>
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import commentTable from '@/components/mixins/commentTable'
import formDialog from '@/components/mixins/formDialog'
import todoMixin from './todoMixin.js'
import {
  mapActions
} from 'vuex'

export default {
  name: 'TodoList',
  mixins: [commentTable, searchHeader, baseHeader, formDialog, todoMixin],
  data () {
    return {
      causeTitle: '编辑回复',
      causeForm: {

      },
      causeRules: {
        replyContent: [this.$rules.required()]
      },
      causeFormItems: [
        {
          prop: 'replyContent',
          type: 'textarea',
          autosize: { minRows: 3 },
          maxlength: 150
        }
      ],
      causeButtons: [
        {
          text: '确定',
          type: 'Submit'
        }
      ],
      rowId: '',
      reportNum: null
    }
  },
  methods: {
    ...mapActions('config', ['FetchSitesOwnsite']),
    handleOpencomment (data, index) {
      this.$routerLink('/interact/comment/Content?contentId=' + data.content.id)
    },
    handleOpenNews (data, index) {
      if (data.content && data.content.urlWhole) {
        window.open(data.content.urlWhole)
      } else {
        this.$message('没有浏览地址')
      }
    },
    // 搜索处理
    handleSearchs () {
      this.list.pageNo = 1
      var params = this.list.params
      /*
      if (params.channel.length > 0) {
        params.channelId = params.channel[params.channel.length - 1]
      }
      if (params.senior) {
        params.fuzzySearch1 = ''
      } else {
        params.fuzzySearch2 = ''
        params.selectID = ''
        params.userName = ''
        params.ip = ''
        params.commentText = ''
        params.replytText = ''
        params.title = ''
        params.startTime = ''
        params.endTime = ''
        params.replyStartTime = ''
        params.replyEndTime = ''
      }
      if (params.criticalTimes) {
        params.startTime = params.criticalTimes[0]
        params.endTime = params.criticalTimes[1]
      } else {
        params.startTime = ''
        params.endTime = ''
      }
      if (params.replyTimes) {
        params.replyStartTime = params.replyTimes[0]
        params.replyEndTime = params.replyTimes[1]
      } else {
        params.replyStartTime = ''
        params.replyEndTime = ''
      }
      if (!params.fuzzySearch2) {
        params.fuzzySearch = params.fuzzySearch1
      } else if (!params.selectID) {
        params.fuzzySearch = params.fuzzySearch2
      } else if (params.selectID === 1) {
        params.userName = params.fuzzySearch2
      } else if (params.selectID === 2) {
        params.ip = params.fuzzySearch2
      } else if (params.selectID === 3) {
        params.commentText = params.fuzzySearch2
      } else if (params.selectID === 4) {
        params.replytText = params.fuzzySearch2
      } else if (params.selectID === 5) {
        params.title = params.fuzzySearch2
      }
      if (params.fuzzySearch2 === '') {
        params.userName = ''
        params.ip = ''
        params.commentText = ''
        params.replytText = ''
        params.title = ''
      }
      */
     if (params.createTime) {
        params.createTimeStart = params.createTime[0]
        params.createTimeEnd = params.createTime[1]
      } else {
        params.createTimeStart = ''
        params.createTimeEnd = ''
      }
      this.list.params = params
      this.fetchCommentApi()
    },
    // 回调
    fetchContentCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map((d, i) => {
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    // 修改回复
    handlePutReply (data) {
      this.rowId = data.id
      this.causeForm = { isUpdate: true }
      this.causeTitle = '修改回复'
      this.$refs.causeDialog.showDialog()
    },
    // 回复
    handleReply (data) {
      this.rowId = data.id
      this.causeForm = { isUpdate: false }
      this.causeTitle = '编辑回复'
      this.$refs.causeDialog.showDialog()
    },
    // 编辑回复
    handleConfirmCause (data) {
      if (this.rowId) {
        data.id = this.rowId
        this.fetchInteractLetterReply(data)
      }
    },
    // 办结
    handlePass (data) {
      this.fetchInteractLetterFinish(data)
    },
    // 删除
    handleDelete (data) {
      let ids = []
      ids.push(data.id)
      this.$confirm('是否确定删除信件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchInteractLetterDelete(ids);
      })
    },
    // 批量删除
    changeCommentDelete (ids) {
      this.$confirm('是否确定批量删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchInteractLetterDelete(ids)
      })
    },
    // 批量点击
    handleBatchAll (ids, btn) {
      if (ids.length > 0) {
        switch (btn.btn) {
          case 'Delete':
            // 删除信件
            this.changeCommentDelete(ids, 1)
            break
          default:
            break
        }
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 接口访问
    fetchInteractLetterFinish (data) {
      this.$request.fetchInteractLetterFinish(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 删除
    fetchInteractLetterDelete (ids) {
      this.$request.fetchInteractLetterDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 回复
    fetchInteractLetterReply (data) {
      this.$request.fetchInteractLetterReply(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 查询列表数量
    fetchInteractUsercommentCount (data) {
      this.$request.fetchInteractUsercommentCount(data).then(res => {
        if (res.code === 200) {
          this.reportNum = res.data.reportNum
        }
      })
    },
  },
  mounted () {
    // this.fetchInteractUsercommentCount()
  },
  activated () {
    // if (this.$route.query.type === 'list') {
    //   this.fetchCommentApi()
    //   // this.fetchInteractUsercommentCount()
    //   this.$router.push({ query: { type: '' } })
    // }
    this.fetchCommentApi()
  }
}
</script>
<style lang='scss'>
.el-popover{
  .ct-pover__box{
    .ct-pover__item{
      .el-link--inner{
        .liulan{
          font-size: 14px!important;
        }
      }

    }
  }
}
.todo-list-container{

  .ct-wrap .ct-box__cont {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    color: #666;
    align-items: center;
    justify-content: space-between;
    background-color: #f9f9f9;
  }
  .ct-wrap .ct-box .ct-box__item {
      align-items: center;
      margin-right: 30px;
  }
  .base-header-container{
    header{
      padding-bottom: 10px!important;
    }
    .list-wrap-btn.el-button.el-button--medium.is-plain{
      border-color: #e8e8e8;
      color: #333333;
      font-size: 14px;
      .jee-svg-icon{
        width: 10px;
        fill: #333333;
      }
    }
  }
}
.todo-list-order-type{
  .el-select-dropdown__wrap{
    max-height: 353px;
  }
}
.todo-list-status{
  .el-select-dropdown__wrap{
    max-height: 290px;
  }
}
</style>
